<!--
    描述：考核系统 --- 考核项
    时间：2021-03-03
    Created by 王帅
    updated by 钱磊 2022-5-18 11:05:04
-->
<template>
	<div class="evaluate-score-main operation-layout pd0">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch('1')" @reset="doRefresh">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchObj" label-width="120px">
					<el-form-item label="考核对象：" prop="markObj">
						<el-select v-model="searchObj.markObj" placeholder="请选择考核对象" clearable>
							<el-option v-for="(item, index) in pdjx" :key="'对象' + index" :label="item.sname" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发布时间：" prop="dateArr" class="date-time">
						<el-date-picker
							v-model="searchObj.dateArr"
							type="daterange"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合计考核项：<span class="blue">{{ searchObj.totalResult }}</span> 条
						</div>
						<div class="btnGroups">
							<el-button class="btn-success" size="small" @click="handleTools('add')">新增</el-button>
						</div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content">
							<vxe-table
								:data="tableObj.tableData"
								:loading="tableObj.loading"
								:border="tableObj.border"
								:resizable="tableObj.resizable"
								:size="tableObj.size"
								:height="tableObj.height"
								highlight-current-row
								highlight-hover-row
								auto-resize
								show-overflow="tooltip"
								show-header-overflow="tooltip"
							>
								<vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
								<vxe-table-column
									v-for="item in activeColumns"
									:key="item.prop"
									:field="item.prop"
									:title="item.title"
									:min-width="item.minWidth"
									:width="item.width"
									:align="item.align"
									:header-align="item.headerAlign"
								>
									<template v-slot="{ row }" v-if="item.needRender">
										<span>{{ item.function(row[item.prop]) }}</span>
									</template>
								</vxe-table-column>
								<vxe-table-column title="操作" min-width="160" align="center">
									<template v-slot="{ row }">
										<el-button type="success" size="small" round plain class="table-btn" @click="handleTools('edit', row)">
											<svg-icon icon-class="form-edit"></svg-icon> 编辑
										</el-button>
										<el-button
											type="danger"
											size="small"
											round
											plain
											class="table-btn"
											icon="el-icon-delete"
											@click="handleTools('delete', row)"
											>删除
										</el-button>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<vxe-pager
								size="mini"
								:current-page="searchObj.currentPage"
								:page-size="searchObj.pageSize"
								:total="searchObj.totalResult"
								class="text-center"
								:page-sizes="[10, 20, 50, 100, { label: '全部数据', value: -1 }]"
								:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
								@page-change="handlePageChange"
							>
							</vxe-pager>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 新增弹窗 -->
		<el-dialog
			:visible.sync="dialogObj.visible"
			:width="dialogObj.width"
			:title="dialogObj.title"
			center
			:close-on-click-modal="false"
			:before-close="beforeClose"
		>
			<el-form ref="addForm" :model="formData" :rules="rules" size="medium" label-width="100px">
				<el-form-item label="考核对象" prop="markObj">
					<el-select v-model="formData.markObj" placeholder="请选择考核对象" clearable @change="onChangeMark">
						<el-option v-for="(item, index) in pdjx" :key="'对象1' + index" :label="item.sname" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="类别" prop="itemType">
					<el-select
						v-model="formData.itemType"
						placeholder="请选择类别"
						filterable
						allow-create
						default-first-option
						clearable
						@change="handlChange"
					>
						<el-option v-for="(item, index) in itemTypeOptions" :key="index" :label="item.sname" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="名称" prop="sname">
					<el-input v-model="formData.sname" placeholder="请输入名称" :maxlength="50" show-word-limit clearable></el-input>
				</el-form-item>
				<el-form-item label="内容" prop="content">
					<el-input v-model="formData.content" placeholder="请输入内容" :maxlength="50" show-word-limit clearable></el-input>
				</el-form-item>
				<el-form-item label="考核标准" prop="standard">
					<el-input
						v-model="formData.standard"
						type="textarea"
						placeholder="请输入考核标准"
						:maxlength="200"
						show-word-limit
						:autosize="{ minRows: 2 }"
					></el-input>
				</el-form-item>
			</el-form>

			<!-- footer 组件 -->
			<div slot="footer" class="pdb10 text-center">
				<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消 </el-button>
				<el-button type="primary" size="small" class="btn btn-blue" :loading="dialogObj.btnLoading" @click="doSave">确 定 </el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as Api from 'api/modules/evaluate-system/EvaluateItem.js'
import { mapState } from 'vuex'

export default {
	name: 'EvaluateIndex',
	data() {
		return {
			showFilter: true,
			searchObj: {
				markObj: '',
				dateArr: [],
				startDate: '',
				endDate: '',
				currentPage: 1,
				pageSize: 10,
				totalResult: 0
			},
			// 表格对象
			tableObj: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			},
			// 弹窗对象
			dialogObj: {
				visible: false,
				width: '600px',
				title: '新增',
				type: 'add',
				btnLoading: false
			},
			formData: {
				markObj: '',
				itemType: '',
				sname: '',
				content: undefined,
				standard: undefined
			},
			reSetFormData: {}, //重置表单
			rules: {
				markObj: [
					{
						required: true,
						message: '请选择考核对象',
						trigger: 'change'
					}
				],
				itemType: [
					{
						required: true,
						message: '请选择类别',
						trigger: 'change'
					}
				],
				sname: [
					{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}
				],
				content: [
					{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}
				],
				standard: [
					{
						required: true,
						message: '请输入考核标准',
						trigger: 'blur'
					}
				]
			},
			itemTypeOptions: []
		}
	},
	created() {
		// 初始查询
		this.doSearch()
		this.reSetFormData = { ...this.formData }
	},
	methods: {
		// 查询数据
		doSearch(page) {
			if (page) {
				this.searchObj.pageSize = 10
				this.searchObj.currentPage = 1
			}
			if (this.searchObj.dateArr && this.searchObj.dateArr.length > 0) {
				this.searchObj.startDate = this.searchObj.dateArr[0] + ' 00:00:00'
				this.searchObj.endDate = this.searchObj.dateArr[1] + ' 23:59:59'
			} else {
				this.searchObj.startDate = ''
				this.searchObj.endDate = ''
			}
			let params = {
				size: this.searchObj.pageSize, // 当前每页条数
				current: this.searchObj.currentPage, // 当前页码
				markObj: this.searchObj.markObj, // 考核对象
				startTime: this.searchObj.startDate, // 创建时间 -- 开始
				endTime: this.searchObj.endDate // 创建时间 -- 结束
			}
			this.tableObj.loading = true
			Api.getListData(params)
				.then((res) => {
					// console.log(res)
					this.tableObj.loading = false
					if (res.operationCode === 1) {
						this.tableObj.tableData = res.data.operateMarkItemPage.records
						this.searchObj.totalResult = parseInt(res.data.operateMarkItemPage.total)
					}
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		// 刷新
		doRefresh() {
			this.searchObj.pageSize = 10
			this.searchObj.currentPage = 1
			this.searchObj.markObj = ''
			this.searchObj.startDate = ''
			this.searchObj.endDate = ''
			this.searchObj.dateArr = []

			this.doSearch()
		},

		// 操作函数
		handleTools(type, row) {
			switch (type) {
				case 'add':
					this.formData = { ...this.reSetFormData }
					this.dialogObj.visible = true
					this.dialogObj.type = 'add'
					this.dialogObj.title = '新增'

					break
				case 'edit':
					this.dialogObj.visible = true
					this.dialogObj.type = 'edit'
					this.dialogObj.title = '编辑'

					// 触发考核对象选择
					this.onChangeMark(row.markObj, row)
					break
				case 'delete':
					this.$confirm('确认删除吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							Api.deleteItem({ id: row.id, isFlag: 0 })
								.then((res) => {
									if (res.operationCode === 1) {
										this.$message.success(res.msg)
									}
									// 刷新页面
									this.doSearch()
								})
								.catch((err) => {})
						})
						.catch(() => {})
					break
			}
		},

		// 考核对象选择
		onChangeMark(value, row) {
			if (value === '') {
				this.itemTypeOptions = []
				this.formData.itemType = ''
				this.formData.itemTypeName = ''
				return
			}
			Api.changeMark({ markObj: value })
				.then((res) => {
					if (res.operationCode === 1) {
						this.itemTypeOptions = res.data
						this.formData.itemType = ''
						this.formData.itemTypeName = ''

						// 触发回显
						if (row) {
							this.formData = JSON.parse(JSON.stringify(row))
							this.formData.itemTypeName = ''
						}
					}
				})
				.catch((err) => {
					this.itemTypeOptions = []
					this.formData.itemType = ''
					this.formData.itemTypeName = ''
				})
		},

		// 类别切换
		handlChange(value) {
			let _noSpaceValue = this.spaceFilter(value)
			// 新增的单独处理
			let _item = this.itemTypeOptions.find((x) => x.id === _noSpaceValue)
			this.formData.itemTypeName = _item ? '' : _noSpaceValue
		},

		// 确认新增、编辑
		doSave() {
			// 按钮状态loading
			this.dialogObj.btnLoading = true

			// 表单验证
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					// console.log(this.formData);
					let params = Object.assign({}, this.formData)
					if (params.itemTypeName !== '') {
						params.itemType = ''
					} else {
						params.itemTypeName = this.itemTypeOptions.find((x) => x.id === params.itemType).sname
					}

					// 编辑时不更新创建人
					if (this.dialogObj.type !== 'edit') {
						params.createUserid = this.userInfo.id
						params.createUser = this.userInfo.sname
					}

					Api.saveOrUpdateItem(params)
						.then((res) => {
							if (res.operationCode === 1) {
								this.dialogObj.visible = false
								// 清除表单字段
								this.resetFields()
								this.$message.success(res.msg)

								this.doSearch()
							}
						})
						.catch((err) => {
							this.dialogObj.btnLoading = false
						})
				} else {
					setTimeout(() => {
						this.dialogObj.btnLoading = false
					}, 2000)
				}
			})
		},

		// 重置新增表单
		resetFields() {
			this.dialogObj.btnLoading = false

			this.$refs.addForm.resetFields()
			this.formData.itemType = ''
			this.formData.itemTypeName = ''
			this.formData.id = ''
		},

		// 关闭弹窗
		beforeClose(done) {
			this.resetFields()
			done()
		},

		// 切换分页
		handlePageChange({ currentPage, pageSize }) {
			this.searchObj.currentPage = currentPage
			this.searchObj.pageSize = pageSize
			this.doSearch()
		},

		// 数据去除空格
		spaceFilter(data) {
			return data.replace(/\s+/, '')
		}
	},
	computed: {
		// 动态列
		activeColumns() {
			let columns = [
				{
					prop: 'markObjName',
					title: '考核对象',
					minWidth: 0,
					width: 120,
					headerAlign: 'center',
					align: 'center'
				},
				{
					prop: 'itemTypeName',
					title: '类别',
					minWidth: 0,
					width: 120,
					headerAlign: 'center',
					align: 'center'
				},
				{
					prop: 'sname',
					title: '名称',
					minWidth: 150,
					width: 0,
					headerAlign: 'center',
					align: 'center'
				},
				{
					prop: 'content',
					title: '内容',
					minWidth: 200,
					width: 0,
					headerAlign: 'center',
					align: 'left'
				},
				{
					prop: 'standard',
					title: '考核标准',
					minWidth: 200,
					width: 0,
					headerAlign: 'center',
					align: 'left'
				},
				{
					prop: 'createUser',
					title: '创建人',
					minWidth: 0,
					width: 100,
					headerAlign: 'center',
					align: 'center'
				},
				{
					prop: 'createDate',
					title: '创建时间',
					minWidth: 0,
					width: 120,
					headerAlign: 'center',
					align: 'center',
					needRender: true,
					function: (val) => {
						return val.slice(0, 10)
					}
				}
			]
			return columns
		},

		// 个人信息
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),

		// 考核对象
		...mapState('evaluate_dict', {
			pdjx: (state) => state.pjdx
		})
	}
}
</script>

<style scoped lang="less"></style>
